import React, { Fragment, useEffect, useState } from 'react';
import "./ApplicationType.css";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from 'reactstrap';
import CustomPagination from '../../../components/Pagination/CustomPagination';
import { getApplicationType, updateApplicationType } from '../../../api/workflow';
import { decryptData } from '../../../utils/helper';
import { failed, success } from '../../../utils/Tostify';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../../components/Loader/Loader';
import moment from 'moment';
import { useConfirmDialog } from '../../../hooks/useConfirmDialog';
import EditApplication from './EditApplication';

function ApplicationTypeList({searchValue, direction, ...args }) {
  let token = useSelector(state => state.userReducer.token);
  const [dropdownOpen, setDropdownOpen] = useState([]);
  const [applicationList, setApplicationList] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [appData, setAppData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const { getConfirmation } = useConfirmDialog();
  const dispatch  = useDispatch();
  const toggleDropdown = (id) => {
    setDropdownOpen(prevState => prevState.includes(id) ? prevState.filter(item => item !== id) : [...prevState, id]);
  };
  const getApplicationTypeList = async (page, limit, searchKey = "") => {
    let res;
    try {
        setIsLoading(true);
        // setSearch(searchKey);
        res = await getApplicationType({dispatch, token, page, limit, searchKey});
        const responseData = decryptData(res?.data);
        if (res?.status === "SUCCESS") {
            setApplicationList(responseData);
            setIsLoading(false);
        }else{
          setIsLoading(false);
          failed(res?.message);
        }
    } catch (error) {
        failed(res?.message);
        setIsLoading(false);
    }
  };

  const handlePagination = (page) => {
    getApplicationTypeList(page, 10);
  };

  const handlePublished = async (e, appId) => {
    const isChecked = e.target.checked;
    e.target.checked = !isChecked;
    const msg = isChecked ? "Publish" : "Unpublish";
    const confirmed = await getConfirmation({
        title: "Attention!",
        entryName: "",
        actionBtnTitle: "Yes",
        message: `Are you sure you want to ${msg}?`
    });
    if (confirmed) {
        let res;
        try {
            const values = {isPublished: isChecked};
            setIsLoading(true);
            res = await updateApplicationType({values, dispatch, token, appId});
            if (res?.status === "SUCCESS") {
                await getApplicationTypeList(applicationList?.currentPage, 10);
                setIsLoading(false);
                success(res?.message);
            } else {
                setIsLoading(false);
                failed(res?.message);
            }
        } catch (error) {
            setIsLoading(false);
            failed(res?.message);
        }
    } else {
        e.target.checked = !isChecked;
    }
  };

  const handleDelete = async(appName, appId)=>{
    const isActive = applicationList?.items?.find((obj)=> obj?._id == appId)?.isPublished;
    if(isActive){
      failed("You can't delete an Published Application Type");
      return;
    }
    const confirmed = await getConfirmation({
        title: "Attention!",
        entryName: "",
        actionBtnTitle: "Yes",
        message: `Are you sure you want to Delete ${appName}?`
    });
    if (confirmed) {
        let res;
        try {
            const values = {isDeleted: true};
            setIsLoading(true);
            res = await updateApplicationType({values, dispatch, token, appId});
            if (res?.status === "SUCCESS") {
                await getApplicationTypeList(applicationList?.currentPage, 10);
                setIsLoading(false);
                success(res?.message);
            } else {
                setIsLoading(false);
                failed(res?.message);
            }
        } catch (error) {
            setIsLoading(false);
            failed(res?.message);
        }
    }
  };

  useEffect(() => {
    getApplicationTypeList(1, 10);
  }, []);
  useEffect(() => {
    let timerOut = setTimeout(async () => {
      getApplicationTypeList(1, 10, searchValue);
    }, 1000);
    return () => clearTimeout(timerOut);
}, [searchValue]);

  return (
    <Fragment>
      {isLoading && <Loader/>}
      {showModal ? <EditApplication refetch={()=> getApplicationTypeList(applicationList?.currentPage, 10)} setShowModal={()=> setShowModal(!showModal)} appData={appData}/> : null}
      <div className="table_space table_listing_color">
        <div className="forms_block_workflow">
          <div className="table-responsive">
            <table>
              <thead>
                <tr className="header_table">
                  <th>Application Type</th>
                  <th>Created By</th>
                  <th>Updated</th>
                  <th>Publish</th>
                  <th>Actions</th>
                </tr>
              </thead>
              {applicationList?.items?.length > 0 ? applicationList?.items.map((app, index) => (
              <tbody key={app._id}>
                <tr>
                  <td colSpan={8} className="bg_light"></td>
                </tr>
                <tr className={index % 2 === 0 ? 'first_block' : 'second_block'}>
                  <td>{app?.applicationTitle}</td>
                  <td>{app?.createdBy?.name}</td>
                  <td>{moment(app?.updatedAt).format("MMM-DD-YYYY")}</td>
                  <td>
                    <div className="toggle">
                        <input
                            type="checkbox"
                            id={`checktoggle-${app._id}`}
                            onChange={(e) => handlePublished(e, app?._id)}
                            checked={app?.isPublished}
                        />
                        <label htmlFor={`checktoggle-${app._id}`}></label>
                    </div>
                  </td>
                  <td>
                    <Dropdown  className="dropdown_blk" isOpen={dropdownOpen.includes(app?._id)} toggle={() => toggleDropdown(app._id)}  direction={direction}>
                        <DropdownToggle caret size="xl" className="column_blk">
                            <div className="for_details">
                              <i className="fa fa-ellipsis-v"></i>
                            </div>
                        </DropdownToggle>
                        <DropdownMenu {...args}>
                            <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={()=> {setShowModal(true); setAppData({...app, readOnly:false});}}>
                                <div className="add_hosp">Edit</div>
                            </DropdownItem>
                            <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={()=> {setShowModal(true); setAppData({...app, readOnly:true});}}>
                                <div className="add_hosp">View Details</div>
                            </DropdownItem>
                            <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={()=> handleDelete(app?.applicationTitle, app?._id)}>
                                <div className="add_hosp" >Delete</div>
                            </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                  </td>
                </tr>
                <tr>
                  <td colSpan={8} className="bg_light"></td>
                </tr>
              </tbody>
              )) : <tr><td colSpan={10}><p className="text-center">No Data Found</p></td></tr>}
            </table>
          </div>
            <CustomPagination
              tableData={applicationList?.items}
              totalPages={applicationList?.totalPages}
              totalRows={applicationList?.totalItems}
              rowsPerPage={10}
              page={applicationList?.currentPage}
              handlePage={handlePagination}
          />
        </div>
      </div>
    </Fragment>
  );
}

export default ApplicationTypeList;
